@if (state) {
  <header>
    <rt-heading variant="heading large-xx light">
      {{ 'app.pricing.plan_picker.choose_a_plan' | translate }}
    </rt-heading>

    <rt-plan-picker-global-controls
      [enableCurrencyChange]="state.showCurrencyControl"
      [enableIntervalChange]="state.showIntervalControl"
      [interval]="state.interval"
      [assignedProduct]="state.assignedProduct"
      [currency]="state.currency"
      [isCustomSubscription]="state.assignedProduct?.custom || state.activeProduct.custom"
      (intervalChange)="changeInterval$.next($event); analytics.trackPaymentIntervalSelect($event)"
      (currencyChange)="changeCurrency$.next($event); analytics.trackCurrencyChange($event)"
    />
  </header>

  @if (!isManualSubscription) {
    <ng-container *ngTemplateOutlet="customProductAssignedMessage" />
  }

  <rt-spam-verification-infobox-container />

  @if (isUpgradingLaunch5$ | ngrxPush) {
    <rt-infobox [isDismissible]="false" iconName="warning" type="warning" margin-bottom>
      {{ 'app.pricing.launch_5' | translate }}
    </rt-infobox>
  }

  <rt-infobox [isDismissible]="false" iconName="info-outline" type="information" margin-bottom
    >{{ 'app.pricing.plan_picker_2024.released_infobox.content' | translate }}&nbsp;<a
      (click)="openPlanPicker2024()"
      >{{ 'app.pricing.plan_picker_2024.released_infobox.cta' | translate }}</a
    >
  </rt-infobox>

  <div class="products">
    <rt-plan-picker-products
      [state]="state"
      (slotsChange)="changeSlots$.next($event)"
      (selected)="continue($event); analytics.trackSelectPlan($event)"
      (cancelSubscription)="cancelSubscription(); analytics.trackChurn()"
    />
  </div>

  <rt-plan-picker-compare
    [highlighted]="state.highlighted"
    [active]="state.isTrial ? '' : codename"
  />
}

<ng-template #customProductAssignedMessage>
  <rt-assigned-product-message-container [disabled]="!!state.assignedProductLimitExceeded" />
</ng-template>
